import React, { useState } from "react";
import { Button, ButtonToolbar, Modal } from "rsuite";
import ModalFooter from "rsuite/esm/Modal/ModalFooter";
import { WeightageVM } from "../../../Models/ViewModels";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { AddEditDeleteWeightage } from "./AddEditDeleteWeightage";
// import { AddEditDeleteProcess } from "./AddEditDeleteProcess";

type attributes = {
  action: string;
  data: WeightageVM;
  onAction: any;
  cachedData: any;
};
export const WightageModal = (props: attributes) => {
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState();
  const handleOpen = (value: any) => {
    setSize(value);
    setOpen(true);
  };
  const handleClose = () => setOpen(false);

  const onAddWightage = (prrDetail: WeightageVM) => {
    handleClose();
    props.onAction(prrDetail);
  };
  const onEditWightage = (prrDetail: WeightageVM) => {
    handleClose();
    props.onAction(prrDetail);
  };
  const onDeleteWightage = (prrDetail: WeightageVM) => {
    handleClose();
    props.onAction(prrDetail);
  };

  if (props.action === "edit") {
    return (
      <div className="modal-container">
        <i
          className="bi bi-pencil-fill text-warning"
          onClick={() => handleOpen("xs")}
        ></i>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteWeightage
            title="Edit Weightage"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onEditWightage}
          />
        </Modal>
      </div>
    );
  } else if (props.action === "add") {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <Button
            appearance="primary"
            color="green"
            size="md"
            onClick={() => handleOpen("xs")}
          >
            <BootstrapIcon
              bootStrapIconName="plus"
              size={15}
              cssClasses="me-1"
            />
            Add
          </Button>
        </ButtonToolbar>

        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteWeightage
            type="add"
            title="Add New Weightage"
            data={props.data}
            cachedData={props.cachedData}
            onAction={onAddWightage}
          />
          <ModalFooter></ModalFooter>
        </Modal>
      </div>
    );
  } else {
    return (
      <div className="modal-container">
        <ButtonToolbar>
          <i
            className="bi bi-trash3-fill text-danger"
            onClick={() => handleOpen("xs")}
          ></i>
        </ButtonToolbar>
        <Modal size={size} open={open} onClose={handleClose}>
          <AddEditDeleteWeightage
            title="Delete Weightage"
            type={props.action}
            data={props.data}
            cachedData={props.cachedData}
            onAction={onDeleteWightage}
          />
        </Modal>
      </div>
    );
  }
};
